import React from 'react';
import arrow from '../../../assets/images/drpdwnArrow.svg';
import cross from '../../../assets/images/close_popup.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../css/announcement/AddAnnouncementModal.css';
import Upload from '../../shared/PdfUpload';
import { hours, minute } from '../../../data/hoursAndMinute';
import message from '../../../data/Message.json';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { ADDANNOUNCEMENT_ENDPOINT, ALLPORTTERMINALS_ENDPOINT } from '../../../Services/config/apiEndPoints';
import SubmitModal from '../../shared/SuccessModal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
class AddAnnouncementModal extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.container = React.createRef();
    this.state = {
      portData: [],
      announcementName: '',
      text: '',
      publishDateTime: new Date(),
      terminalSelectStatus: [],
      selectPlaceHolder: '- - Select - -',
      dropdown: false,
      checked: false,
      selectAll: false,
      effectiveDateCalendar: new Date(),
      effectiveDateHourValue: '00',
      effectiveDateMinuteValue: '00',
      expiryDateCalendar: new Date(),
      expiryDateHourValue: '23',
      expiryDateMinuteValue: '59',
      showEffectiveCalendar: false,
      showExpiryCalendar: false,
      dropDownExpiryHour: false,
      dropDownExpiryMinute: false,
      dropDownEffectiveHour: false,
      dropDownEffectiveMinute: false,
      expiryDateHours: [],
      expiryDateMinutes: [],
      pdfUploadLink: "",
      textLimit: 0,
      errors: {},
      renderEffectiveCalendar: false,
      renderExpiryCalendar: false,
      isUploadDisabled: false,
      publishHasOpen: false,
      loadAllPortTerminals: false,
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  validateFormFields = () => {
    return this.state.terminalSelectStatus.includes(true) &&
    // this.state.checked == true &&
      this.state.renderEffectiveCalendar && this.state.renderExpiryCalendar &&
      this.state.expiryDateHourValue !== '' &&
      this.state.effectiveDateHourValue !== '' && this.state.expiryDateMinuteValue !== ''
      && this.state.effectiveDateMinuteValue !== '' &&
      this.state.announcementName.length > 0 &&
      (this.state.text.length > 0 || this.state.pdfUploadLink.length > 0)
  };
  onPublish = () => {
    if (this._isMounted === true) {
      this.setState({ publishHasOpen: false })
      this.props.onClosePublish()
    }
  }
  handleSubmit = () => {
    if (this.handleValidation()) {
      this.getPublish();
    }
  }
  handleValidation() {
    let errors = {};
    let formIsValid = true;
    let patternCharacter = new RegExp(/^[a-zA-Z ]*$/);
    if (!patternCharacter.test(this.state.announcementName)) {
      formIsValid = false;
      errors["announcementName"] = message.validation.alpha;
    }
    if (this.state.effectiveDateCalendar.getFullYear() > this.state.expiryDateCalendar.getFullYear()) {
      formIsValid = false;
      errors["todate"] = message.validation.dateTime;
    }
    if (this.state.effectiveDateCalendar.getFullYear() == this.state.expiryDateCalendar.getFullYear()) {
      if (this.state.effectiveDateCalendar.getMonth() > this.state.expiryDateCalendar.getMonth()) {
        formIsValid = false;
        errors["todate"] = message.validation.dateTime;
      }
    }
    if (this.state.effectiveDateCalendar.getFullYear() == this.state.expiryDateCalendar.getFullYear()) {
      if (this.state.effectiveDateCalendar.getMonth() == this.state.expiryDateCalendar.getMonth()) {
        if (this.state.effectiveDateCalendar.getDate() > this.state.expiryDateCalendar.getDate()) {
          formIsValid = false;
          errors["todate"] = message.validation.dateTime;
        }
        if (this.state.effectiveDateCalendar.getDate() == this.state.expiryDateCalendar.getDate()) {
          if (this.state.effectiveDateHourValue > this.state.expiryDateHourValue) {
            formIsValid = false;
            errors["todate"] = message.validation.dateTime;
          }
        }
        if (this.state.effectiveDateCalendar.getDate() == this.state.expiryDateCalendar.getDate()) {
          if (this.state.effectiveDateHourValue == this.state.expiryDateHourValue) {
            if (this.state.effectiveDateMinuteValue >= this.state.expiryDateMinuteValue) {
              formIsValid = false;
              errors["todate"] = message.validation.dateTime;
            }
          }
        }
      }
    }
    if (this._isMounted === true) {
      this.setState({ errors: errors });
    }
    return formIsValid;
  }
  componentWillUnmount = () => {
    this._isMounted = false;
  }
  componentDidMount = () => {
    this._isMounted = true;
    document.addEventListener("mousedown", this.handleClickOutside);
    console.log("pdf link", this.state.pdfUploadLink)
    console.log(this.state.publishDateTime.getTime());
    ApiCall(
      'GET',
      utilityBaseURL + ALLPORTTERMINALS_ENDPOINT,
      {},
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-cc-trace-id': '1234',
      },
    ).then((data) => {
      if (this._isMounted === true) {
        if (data.flag !== -1) {
          if (data.flag === 500) {
            this.setState({ loadAllPortTerminals: false });
          }
          else {
            console.log('I am 200!');
            console.log("port", data, data.data)
            this.setState({ portData: data }, () => {
              let terminalSelectStatus = [];
              this.state.portData.forEach((s, index) => {
                terminalSelectStatus.push(false)
              })
              this.setState({ terminalSelectStatus: terminalSelectStatus })
            });
            this.setState({ loadAllPortTerminals: true });
          }
        } else {
          // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
        }
      }
    });
  };
  toggleEffectiveCalendar = () => {
    if (this._isMounted === true) {
      this.setState({ showEffectiveCalendar: !this.showEffectiveCalendar, renderEffectiveCalendar: true });
    }
  }
  toggleExpiryCalendar = () => {
    if (this._isMounted === true) {
      this.setState({ showExpiryCalendar: !this.showExpiryCalendar, renderExpiryCalendar: true });
    }
  }
  //formDate
  handleEffectiveDateChanged = (e) => {
    if (this._isMounted === true) {
      this.setState({
        effectiveDateCalendar: e, showEffectiveCalendar: false,
        errors: {
          ...this.state.errors,
          todate: ''
        }
      });
    }
  }
  changeEffectiveHour = (event) => {
    if (this._isMounted === true) {
      const found = hours.find((name) => {
        if (name.hour === event.target.innerText) {
          return name;
        }
      })
      this.setState({ effectiveDateHourValue: found.hour });
      this.setState({
        dropDownEffectiveHour: false,
        errors: {
          ...this.state.errors,
          todate: ''
        }
      })
    }
  };
  changeEffectiveMinute = (event) => {
    if (this._isMounted === true) {
      const found = minute.find((name) => {
        if (name.m === event.target.innerText) {
          return name;
        }
      })
      this.setState({ effectiveDateMinuteValue: found.m });
      this.setState({
        dropDownEffectiveMinute: false,
        errors: {
          ...this.state.errors,
          todate: ''
        }
      })
    }
  };
  //toDate
  handleExpiryDateChanged = (e) => {
    if (this._isMounted === true) {
      this.setState({
        expiryDateCalendar: e, showExpiryCalendar: false,
        errors: {
          ...this.state.errors,
          todate: ''
        }
      });
      let found = hours.filter((name) => {
        if (this.state.effectiveDateCalendar.getTime() === e.getTime()) {
          if (parseInt(name.hour) >= parseInt(this.state.effectiveDateHourValue)) {
            return true;
          }
        }
        if (this.state.effectiveDateCalendar.getTime() !== e.getTime()) {
          return true;
        }
      })
      this.setState({ expiryDateHours: found });
    }
  }
  changeExpiryHour = (event) => {
    if (this._isMounted === true) {
      const found = hours.find((name) => {
        if (name.hour === event.target.innerText) {
          return name;
        }
      })
      this.setState({ expiryDateHourValue: found.hour });
      this.setState({
        dropDownExpiryHour: false,
        errors: {
          ...this.state.errors,
          todate: ''
        }
      })
      let found1 = minute.filter((name) => {
        if (this.state.effectiveDateCalendar.getTime() === this.state.expiryDateCalendar.getTime()) {
          if (parseInt(found.hour) === parseInt(this.state.effectiveDateHourValue)) {
            if (parseInt(name.m) > parseInt(this.state.effectiveDateMinuteValue)) {
              console.log('success');
              return true;
            }
          }
          if (parseInt(found.hour) !== parseInt(this.state.effectiveDateHourValue)) {
            return true;
          }
        }
        if (this.state.effectiveDateCalendar.getTime() !== this.state.expiryDateCalendar.getTime()) {
          return true;
        }
      })
      this.setState({ expiryDateMinutes: found1 });
    }
  };
  changeExpiryMinute = (event) => {
    if (this._isMounted === true) {
      const found = minute.find((name) => {
        if (name.m === event.target.innerText) {
          return name;
        }
      })
      this.setState({ expiryDateMinuteValue: found.m });
      this.setState({
        dropDownExpiryMinute: false,
        errors: {
          ...this.state.errors,
          todate: ''
        }
      })
    }
  };
  handleClickOutside = event => {
    if (this._isMounted === true) {
      if (this.container.current && !this.container.current.contains(event.target)) {
        this.setState({ dropdown: false });
        this.setState({ showEffectiveCalendar: false });
        this.setState({ showExpiryCalendar: false });
        this.setState({ dropDownExpiryHour: false });
        this.setState({ dropDownExpiryMinute: false });
        this.setState({ dropDownEffectiveHour: false });
        this.setState({ dropDownEffectiveMinute: false });
      }
    }
  };
  toggleDropdown = () => {
    if (this._isMounted === true) {
      this.setState({ dropdown: !this.dropdown });
    }
  };
  toggleExpiryHourDropdown = () => {
    if (this._isMounted === true) {
      this.setState({ dropDownExpiryHour: !this.dropDownExpiryHour });
    }
  };
  toggleExpiryMinuteDropdown = () => {
    if (this._isMounted === true) {
      this.setState({ dropDownExpiryMinute: !this.dropDownExpiryMinute });
    }
  };
  toggleEffectiveHourDropdown = () => {
    if (this._isMounted === true) {
      this.setState({ dropDownEffectiveHour: !this.dropDownEffectiveHour });
    }
  };
  toggleEffectiveMinuteDropdown = () => {
    if (this._isMounted === true) {
      this.setState({ dropDownEffectiveMinute: !this.dropDownEffectiveMinute });
    }
  };
  setPdfUploadLink = (imagePathURL) => {
    this.setState({ pdfUploadLink: imagePathURL })
  }
  removePdfUploadedLink = () => {
    if (this._isMounted === true) {
      this.setState({ pdfUploadLink: '' })
    }
  }
  handleTextMessage = (e) => {
    if (this._isMounted === true) {
      if (e.target.value.length <= 500) {
        this.setState({ textLimit: e.target.value.length });
        this.setState({ text: e.target.value });
      }
    }
  }
  getPublish = () => {
    let fromTimeStamp = this.state.effectiveDateCalendar.toString().substring(4, 15) + ' ' + this.state.effectiveDateHourValue + ':' + this.state.effectiveDateMinuteValue;
    let toTimeStamp = this.state.expiryDateCalendar.toString().substring(4, 15) + ' ' + this.state.expiryDateHourValue + ':' + this.state.expiryDateMinuteValue;
    ApiCall(
      'POST',
      utilityBaseURL + ADDANNOUNCEMENT_ENDPOINT,
      {
        "announcementCategory": this.state.announcementName,
        "announcementFrom": Date.parse(fromTimeStamp),
        "announcementTo": Date.parse(toTimeStamp),
        "attachment": this.state.pdfUploadLink,
        "ports": this.getSelectedTerminals(),
        "publishTime": this.state.publishDateTime.getTime(),
        "text": this.state.text,
      },
      {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-cc-trace-id': '1234',
      }
    ).then(data => {
      if (this._isMounted === true) {
        if (data.flag !== -1) {
          if (data.flag === 500) {
            toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
          }
          else {
            console.log('I am 200!');
            this.setState({ publishHasOpen: true })
          }
        }
        else {
          // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
        }
      }
    })
  }
  getSelectedTerminals() {
    let selectedTerminals = [];
    this.state.terminalSelectStatus.map((val, key) => {
      if (val) {
        selectedTerminals.push({
          portId: this.state.portData[key].portId,
          portName: this.state.portData[key].portName,
          portType: this.state.portData[key].portType,
          portCode: this.state.portData[key].portCode,
          integratedWith: this.state.portData[key].integratedWith,
          portFromDate: this.state.portData[key].portFromDate,
          portToDate: this.state.portData[key].portToDate,
          weatherUrl: this.state.portData[key].weatherUrl
        });
      }
    })
    console.log(selectedTerminals)
    return selectedTerminals;
  }
  render() {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let effectiveDateValue = this.state.effectiveDateCalendar.getDate() + "-" + months[this.state.effectiveDateCalendar.getMonth()] + "-" + this.state.effectiveDateCalendar.getFullYear();
    if (this.state.effectiveDateCalendar.getDate() <= 9) {
      effectiveDateValue = "0" + effectiveDateValue;
    }
    let expiryDateValue = this.state.expiryDateCalendar.getDate() + "-" + months[this.state.expiryDateCalendar.getMonth()] + "-" + this.state.expiryDateCalendar.getFullYear();
    if (this.state.expiryDateCalendar.getDate() <= 9) {
      expiryDateValue = "0" + expiryDateValue;
    }
    return (
      <div class="announcementModalOuter" >
        <MetaDecorator title={TitleDescription.addAnnouncementModelPageTitle} description={TitleDescription.addAnnouncementModelPageDescription} />
        <div class="announcementModalInner" >
          <div className='cross'>
            <img src={cross} width="21" height="21" onClick={this.props.onClick} class="d-inline-block align-top" alt="" loading="lazy" />
          </div>
          <div class="upperdiv">
            <small class="announcementModalTitle">
              Add Announcement
            </small>
          </div>
          <div class="lowerdiv">
            <div class="lowerInner">
              <div class="lowerSubInner">
                <div class="leftPart">
                  <div>
                    <small class="announcementFieldsTitle">Terminals</small>
                    <div class="terminalsContainer">
                      <div class="terminalsField">
                        {!this.state.checked
                          ?
                          <small class="terminalPlaceholder">{this.state.selectPlaceHolder}</small>
                          :
                          <div class="announcementTooltip">
                            <small class="selectedTerminals">{this.getSelectedTerminals().map((val, key) => (
                              val.portName.split(':')[0]
                            )).join(', ')}
                            </small>
                            <div class="announcementTooltipOuter">
                              <span class="announcementTooltopTextContainer">
                                <div class="terminalsTooltip">
                                  <div class="terminalsTooltipInner">
                                    <small class="terminalsTooltipText">
                                      {this.getSelectedTerminals().map((val, key) => (
                                        val.portName.split(':')[0]
                                      )).join(', ')}
                                    </small>
                                  </div>
                                </div>
                              </span>
                            </div>
                          </div>
                        }
                        <img class="terminalDropdown" onClick={this.toggleDropdown} src={arrow} alt="Second slide" />
                      </div>
                      {this.state.dropdown && (
                        <div class="terminalDropdownContainer">
                          <div class="border" id="terminaldDropdownOuter" ref={this.container} >
                            <dl style={{ marginBottom: "0.1rem" }}>
                              <dt>
                                <small class="p-1" id="terminalData">
                                  <img
                                    src={this.state.selectAll ?
                                      require('../../../assets/images/checkedBox.svg') :
                                      require('../../../assets/images/uncheckedBox.svg')
                                    }
                                    alt=""
                                    width="32"
                                    height="32"
                                    class="d-inline-block pl-2 pr-2"
                                    onClick={() => {
                                      let a = this.state.terminalSelectStatus;
                                      a = a.map(x => !this.state.selectAll);
                                      this.setState({ terminalSelectStatus: a, selectAll: !this.state.selectAll });
                                      this.setState({ checked: true })
                                      // this.setState({ checked: !this.state.checked })
                                      console.log("select All", a)
                                    }
                                    }
                                  />
                                Select All
                              </small>
                              </dt>
                              {this.state.loadAllPortTerminals && this.state.portData.map((data, index) => {
                                return (
                                  <dt key={index}>
                                    <small class="p-1" id="terminalData">
                                      <img
                                        src={this.state.terminalSelectStatus[index] ?
                                          require('../../../assets/images/checkedBox.svg') :
                                          require('../../../assets/images/uncheckedBox.svg')
                                        }
                                        alt=""
                                        width="32"
                                        height="32"
                                        class="d-inline-block pl-2 pr-2"
                                        onClick={() => {
                                          let a = this.state.terminalSelectStatus;
                                          a[index] = !this.state.terminalSelectStatus[index];
                                          this.setState({ selectAll: false, terminalSelectStatus: a });
                                          this.setState({ checked: true })
                                          // this.setState({ checked: !this.state.checked })
                                          console.log("each terminal select", a)
                                        }}
                                      />
                                      {data.portName.split(':')[0]}
                                    </small>
                                  </dt>
                                )
                              }
                              )}
                            </dl>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div class="announcementEffectiveContainer">
                    <small class="announcementFieldsTitle">Effective Date & Time</small>
                    <div class="announcementDateRow">
                      <div class="announcementDateInput">
                        <input class="announcementInputBox" placeholder="Select Date"
                          value={this.state.renderEffectiveCalendar ? effectiveDateValue : null}
                        ></input>
                      </div>
                      <div class="announcementCalender">  {this.state.showEffectiveCalendar ? <div ref={this.container}> <Calendar onChange={this.handleEffectiveDateChanged} value={this.effectiveDateCalendar} minDate={new Date()} /></div> : null}</div>
                      <img src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-1 " alt="" loading="lazy" onClick={this.toggleEffectiveCalendar}
                      />
                      <div class="hourMinuteDiv">
                        <input class="announcementInputBox" placeholder="HH" value={this.state.effectiveDateHourValue}></input>
                      </div>
                      <img class="pl-2 pr-2" src={arrow} alt="Second slide" onClick={this.toggleEffectiveHourDropdown} />
                      <div>
                        {this.state.dropDownEffectiveHour && (
                          <div class="border" id="announcementHourDropdown" ref={this.container} >
                            {
                              hours.map((datah, indexh) => {
                                return (
                                  <table class="announcementHourHover">
                                    <tr onClick={(index1) => this.changeEffectiveHour(index1)}>
                                      <small class="hourMinuteText">{datah.hour}</small>
                                    </tr>
                                  </table>
                                )
                              }
                              )}
                          </div>
                        )}</div>
                      <div class="hourMinuteDiv">
                        <input class="announcementInputBox" placeholder="MM" value={this.state.effectiveDateMinuteValue}></input>
                      </div>
                      <img class="pl-2 pr-2" src={arrow} alt="Second slide" onClick={this.toggleEffectiveMinuteDropdown} />
                      <div>
                        {this.state.dropDownEffectiveMinute && (
                          <div class="border" id="announcementMinuteDropdown" ref={this.container} >
                            {
                              minute.map((datam, indexh) => {
                                return (
                                  <table class="announcementHourHover">
                                    <tr onClick={(index1) => this.changeEffectiveMinute(index1)}>
                                      <small class="hourMinuteText">{datam.m}</small>
                                    </tr>
                                  </table>
                                )
                              }
                              )}
                          </div>
                        )}</div>
                    </div>
                    <div className="errordateTime">{this.state.errors["todate"]}</div>
                  </div>
                  <div class="announcementUploadContainer">
                    <div class="announcementUploadTitle">
                      <small class="announcementFieldsTitle">Upload PDF for Announcement</small>
                    </div>
                    <div class="announcementUploadPdf">
                      <Upload
                        setImageLink={this.setPdfUploadLink}
                        isUploadDisabled={this.state.isUploadDisabled}
                        removeLink={this.removePdfUploadedLink}
                      ></Upload>
                    </div>
                  </div>
                </div>
                <div class="rightPart">
                  <div class="announcementCategoryContainer">
                    <small class="announcementFieldsTitle">Announcement Category</small>
                    <input class="announcementInputBox" type="text" value={this.state.announcementName} onChange={(e) => {
                      if (e.target.value.length <= 25) {
                        this.setState({
                          announcementName: e.target.value,
                          errors: {
                            ...this.state.errors,
                            announcementName: ''
                          }
                        });
                      } console.log("Terminal Status: ", this.state.terminalSelectStatus)
                    }} placeholder="Enter category"></input>
                    <div className="announcementCategoryError">{this.state.errors["announcementName"]}</div>
                  </div>
                  <div class="announcementExpiryContainer">
                    <small class="announcementFieldsTitle">Expiry Date & Time</small>
                    <div class="announcementDateRow">
                      <div class="announcementDateInput">
                        <input class="announcementInputBox" placeholder="Select Date" value={this.state.renderExpiryCalendar ? expiryDateValue : null}></input>
                      </div>
                      <div class="announcementCalender">  {this.state.showExpiryCalendar ? <div ref={this.container}> <Calendar onChange={this.handleExpiryDateChanged} value={this.expiryDateCalendar} minDate={this.state.effectiveDateCalendar} /></div> : null}</div>
                      <img src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block mr-1" alt="" loading="lazy" onClick={this.toggleExpiryCalendar}
                      />
                      <div class="hourMinuteDiv">
                        <input class="announcementInputBox" placeholder="HH" value={this.state.expiryDateHourValue}></input>
                      </div>
                      <img class="pl-2 pr-2" src={arrow} onClick={this.toggleExpiryHourDropdown} alt="Second slide" />
                      <div>
                        {this.state.dropDownExpiryHour && (
                          <div class="border" id="announcementHourDropdown" ref={this.container} >
                            {this.state.expiryDateHours.map((datah, indexh) => {
                              return (
                                <table class="announcementHourHover">
                                  <tr onClick={(index1) => this.changeExpiryHour(index1)}>
                                    <small class="hourMinuteText">{datah.hour}</small>
                                  </tr>
                                </table>
                              )
                            }
                            )}
                          </div>
                        )}</div>
                      <div class="hourMinuteDiv">
                        <input class="announcementInputBox" placeholder="MM" value={this.state.expiryDateMinuteValue}></input>
                      </div>
                      <img class="pl-2 pr-2" src={arrow} onClick={this.toggleExpiryMinuteDropdown} alt="Second slide" />
                      <div>
                        {this.state.dropDownExpiryMinute && (
                          <div class="border" id="announcementMinuteDropdown" ref={this.container} >
                            {this.state.expiryDateMinutes.map((datam, indexh) => {
                              return (
                                <table class="announcementHourHover">
                                  <tr onClick={(index1) => this.changeExpiryMinute(index1)}>
                                    <small class="hourMinuteText">{datam.m}</small>
                                  </tr>
                                </table>
                              )
                            }
                            )}
                          </div>
                        )}</div>
                    </div>
                  </div>
                  <div class="announcementMessageContainer">
                    <small class="announcementFieldsTitle">Text Message for Announcement </small>
                    <textarea class="announcementTextarea" placeholder="Enter your message" type="text" value={this.state.text}
                      id="textMessage"
                      onChange={this.handleTextMessage}
                    ></textarea>
                    <small class="announcementTextLimit">{this.state.textLimit}/500</small>
                  </div>
                  <div class="announcementPublishContainer">
                    <button disabled={!this.validateFormFields()} onClick={this.handleSubmit} class="announcementPublishButton"><small class="announcementPublishText">Publish</small></button>
                  </div>
                </div>
                {/* note */}
                <div>
                  <p className="announcementNote"><b className="note">Note:</b> Announcement can be published as Text, PDF or both</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SubmitModal onClick={this.onPublish} hasOpen={this.state.publishHasOpen} >
          <div className="sectionTextContainer">
            <p className="sectionText">Your announcement has been published successfully</p>
          </div>
        </SubmitModal>
      </div>
    );
  }
}
export default AddAnnouncementModal;